/**
 * Angular 2 decorators and services
 */
import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  Input,
} from '@angular/core';

import { E2E_ATTRIBUTES } from '@app/shared/types/enums/e2e-attributes.enum';
import { BaseComponent } from '../../components/base-component';

/**
 *
 * Modal Popup component.
 * @class ModalComponent
 *
 */

@Component({
  selector: 'modal',
  styleUrls: ['./modal.component.scss'],
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ModalComponent extends BaseComponent {
  public E2E_ATTRIBUTES: typeof E2E_ATTRIBUTES = E2E_ATTRIBUTES;
  /**
   *
   * @Input title Set modal title text
   *
   */
  @Input() public title: string;
  @Input() public contentTitle: string;
  @Input() public modalCSSClass = 'modal';
  @Input() public modalContentStyle: Record<string, string>;

  public constructor(injector: Injector) {
    super(injector);
  }
}
